import { HomeButtonClickEventName } from "event-tracker/button-click-event-name";
import {
  dataLayerClickedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

const NewEstagioArtistaSemQuiz: React.FC<any> = () => {
  const history = useHistory<any>();
  const { t } = useTranslation();
  return (
    <div className="home">
      <div className="direction">
        <div className="content">
          <h1>{t("pages.Home.welcome")}</h1>
          <h3>{t("pages.Home.subtext")}</h3>
          <span className="message">{t("pages.Home.intro")}</span>
          <button
            className="botao-roxo"
            onClick={() => {
              dataLayerClickedEvent(HomeButtonClickEventName.RUN_DIAGNOSE, {
                ...tagManagerEvent.Home.S4A_HOME_UNDIAGNOSED,
              });

              history.push("/quiz");
            }}
          >
            {t("pages.Home.start")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewEstagioArtistaSemQuiz;
